import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  inject,
  input,
} from '@angular/core';
import { IProductIconNames } from '@epicuro-next/models/products';
import { DynamicComponentsModule } from '@epicuro-next/platform/dynamic-components';
import { DynamicLocalePipe } from '@epicuro-next/platform/i18n';
import { selectHideDiscountLabelByWsp } from '@epicuro-next/state/user-state';
import { Store } from '@ngrx/store';
import { ProductLabel, ProductLabelType } from 'graphql-api/gql-api-interfaces';

import {
  defaultProductLabelLocation,
  mapProductLabelToDynamicItem,
  ProductLabelLocation,
} from './map-product-label-to-dynamic-items';

@Component({
  selector: 'atx-product-labels',
  imports: [CommonModule, DynamicComponentsModule],
  providers: [DynamicLocalePipe],
  templateUrl: './product-labels.component.html',
  styleUrl: './product-labels.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductLabelsComponent {
  private store = inject(Store);

  public location = input<ProductLabelLocation>(ProductLabelLocation.Right);
  public productLabels = input<ProductLabel[]>([]);
  public shownLabelsLimit = input<number | undefined>();

  private readonly hideDiscount = this.store.selectSignal(
    selectHideDiscountLabelByWsp,
  );

  @HostBinding('class') get locationClass() {
    return `${this.location()}__labels`;
  }

  public labelItems = computed(() => {
    const hideDiscount = this.hideDiscount();
    return (this.productLabels() ?? [])
      .filter(({ labelType, data, name }) => {
        if (
          hideDiscount &&
          name.toLowerCase().includes(IProductIconNames.Discount)
        ) {
          return false;
        }

        if (labelType === ProductLabelType.Frame) {
          return false;
        }

        return (
          this.location() === ProductLabelLocation.All ||
          (data.location ?? defaultProductLabelLocation) === this.location()
        );
      })
      .sort((a, b) =>
        parseInt(a.data?.order ?? '1', 10) > parseInt(b.data?.order ?? '1', 10)
          ? 1
          : -1,
      )
      .slice(0, this.shownLabelsLimit() ?? undefined)
      .map(mapProductLabelToDynamicItem)
      .filter(Boolean);
  });
}
